import { trackingInit } from "@tvg/amplitude";
import CrossProductNavigation from "./modules/crossProductNavigation";
import Derby from "./modules/derby";
import EducationalHub from "./modules/educationalHub";
import MyBets from "./modules/myBets";
import ProgramPage from "./modules/programPage";
import VideoPlayer from "./modules/videoPlayer";
import PickBetsOnBoarding from "./modules/pickBetsOnBoarding";
import Preferences from "./modules/preferences";
import RacePage from "./modules/racePage";
import Header from "./modules/header";

export const init = () => {
  trackingInit();
  CrossProductNavigation();
  Derby();
  EducationalHub();
  MyBets();
  ProgramPage();
  VideoPlayer();
  PickBetsOnBoarding();
  Preferences();
  RacePage();
  Header();
};
